import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { api } from "../lib/api";
import { saveSession, type Session } from "../lib/auth";

/**
 * Ziel des Anmelde-Links aus der E-Mail (Anmeldung ohne Passwort).
 *
 * Supabase hängt die Token als Fragment an die Adresse
 * (#access_token=...&refresh_token=...). Das Fragment geht nie an einen Server -
 * wir lesen es im Browser aus, tauschen es einmal gegen eine Sitzung und
 * räumen es dann aus der Adresszeile.
 */
export function Anmelden() {
  const navigate = useNavigate();
  const [fehler, setFehler] = useState<string | null>(null);

  useEffect(() => {
    const frag = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const accessToken = frag.get("access_token");
    const refreshToken = frag.get("refresh_token");
    const beschreibung = frag.get("error_description");

    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }

    if (beschreibung) {
      setFehler(beschreibung);
      return;
    }
    if (!accessToken || !refreshToken) {
      setFehler("Dieser Link ist abgelaufen oder wurde schon benutzt.");
      return;
    }

    api<Session>("/auth/session-from-token", {
      method: "POST",
      body: { accessToken, refreshToken },
      auth: false,
    })
      .then((s) => {
        saveSession(s);
        navigate(s.user.role === "superadmin" ? "/master" : "/app/dashboard", {
          replace: true,
        });
      })
      .catch(() =>
        setFehler("Dieser Link ist abgelaufen oder wurde schon benutzt."),
      );
  }, [navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-elevated">
        {fehler ? (
          <>
            <div className="flex items-start gap-2 rounded-xl bg-amber-50 p-4 text-left text-sm text-amber-900">
              <AlertCircle className="mt-0.5 h-4 w-4 flex-none" />
              <span>{fehler}</span>
            </div>
            <button
              onClick={() => navigate("/login", { replace: true })}
              className="btn-primary mt-5 w-full justify-center"
            >
              Neuen Link anfordern
            </button>
          </>
        ) : (
          <p className="text-slate-600">Sie werden angemeldet …</p>
        )}
      </div>
    </div>
  );
}
